import { Text } from '@components/primitives/Text'
import type { TrialAssociation } from '@modules/trials/types/TrialAssociation'
import { BlankPiImage } from './ProfileImage'

type PartyIndividual = {
  affiliation?: string | null
  isLead?: boolean
  name: string
  role?: string | null
  type?: 'collaborator' | 'official'
}

export const SponsorProfile = ({
  individual,
}: {
  individual: PartyIndividual | TrialAssociation['overallOfficials'][0]
}) => {
  const sponsorName = individual.name?.toLowerCase().startsWith('call ')
    ? null
    : individual.name

  return (
    <div className='flex items-center gap-8'>
      <div className='hidden md:inline-block '>
        <BlankPiImage />
      </div>
      <div>
        <div className='flex flex-col'>
          {sponsorName && (
            <Text
              className={'line-clamp-1 break-normal'}
              styleName='p-strong'
              value={sponsorName}
            />
          )}
          {individual.role && (
            <Text
              className='break-normal text-neutral600'
              styleName='p'
              value={individual.role}
            />
          )}
          {individual.affiliation && (
            <Text
              className='line-clamp-1 text-neutral500'
              styleName='p'
              value={individual.affiliation}
            />
          )}
        </div>
      </div>
    </div>
  )
}
